export function shouldDisplayNewsBannerInBooking(newsBanner, showNewsBanner = false) {
  if (!showNewsBanner || newsBanner === null) return false;

  if (newsBanner.masterHideBanner) return false;

  return true;
}
